var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 6.6387C23.7612 5.22345 24.5899 3.22144 24.29 1.17773C22.501 1.30191 20.4104 2.4499 19.1919 3.94488C18.0805 5.30121 17.1663 7.31552 17.5225 9.27302C19.477 9.3342 21.4967 8.15878 22.6667 6.6387Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3594 12.4655C29.6415 10.3057 27.228 9.05225 24.9482 9.05225C21.939 9.05225 20.6661 10.4973 18.5753 10.4973C16.4196 10.4973 14.7815 9.05661 12.1792 9.05661C9.62293 9.05661 6.90085 10.6234 5.17475 13.3021C2.74862 17.0746 3.16402 24.1672 7.09597 30.2084C8.50292 32.3702 10.382 34.8009 12.84 34.822C15.0269 34.8427 15.6434 33.415 18.6069 33.4004C21.5699 33.3836 22.1322 34.8411 24.3151 34.8178C26.7751 34.7987 28.7569 32.1048 30.164 29.9434C31.1726 28.3937 31.5483 27.6138 32.3301 25.864C26.6407 23.692 25.7286 15.5795 31.3594 12.4655Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLight);
export default __webpack_public_path__ + "static/media/Apple-light.f9889cb122f9b85fadd9f7e49d56fbd7.svg";
export { ForwardRef as ReactComponent };